import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from "lodash";
import CompleteTableData from '../../../../../app/common-components/Table/CompleteTableData';
import { getSortingValues } from '../../../../../app/Constants';
import { getProjectGitLabList, getProjectJiraList, getProjectSonarCubeList } from './ProjectsSlice';


const JiraLanding = (props) => {

    const activeTab = props.activeTab;
    const dispatch = useDispatch();
    const [state, setState] = useState({
        sortByColumn: "",
        sortingOrder: "",
        headerSortingState: {
            accessor: "",
            isDataSorted: "",
        },
    });
    const [pageNo, setPageNo] = useState(0);
    const [pageLimit, setPageLimit] = useState(10);
    const [searchKey, setSearchKey] = useState("");

    const { projectJiraListData,
        projectJiraListLoading,
        projectGitLabListData,
        projectGitLabListLoading,
        projectSonarCubeListData,
        projectSonarCubeListLoading
    } = useSelector((state) => state.projectsapi);

    const getPayload =(key =searchKey, sortingField, isDataSorted ) => {
        const payload  = {
            keyword : key ? key : "",
            // sortByColumn : typeof sortingField !== "undefined" ?  sortingField : "",
            // sortingOrder : typeof isDataSorted !== "undefined" ?  isDataSorted : "",
        };

        return payload;
    };

    const fetchData = (payload, pageNumber, pageLimit) => {
        console.log("fetching");
        console.log(activeTab);
        if (activeTab === "jira") {
            dispatch(getProjectJiraList({ payload, pageNumber, itemsPerPage: pageLimit }));
        }
        else if (activeTab === "gitlab") {
            dispatch(getProjectGitLabList({ payload, pageNumber, itemsPerPage: pageLimit }));
        }else{
            dispatch(getProjectSonarCubeList({ payload, pageNumber, itemsPerPage: pageLimit }));
        }
    };

    useEffect(() => {
        if (activeTab === "jira" || activeTab === "gitlab"|| activeTab === "sonarQube") {
            const payload = getPayload("");
            fetchData(payload, 0, 10);
        }
    }, [activeTab]);

    const listCount = activeTab === 'jira' ? projectJiraListData?.totalCount : activeTab === "sonarQube" ? projectSonarCubeListData?.totalCount || 0 :projectGitLabListData?.totalCount || 0;
    const calculatedPageCount = Math.ceil(listCount / pageLimit);
    const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

    const handleOnSorting = (column, SortingState) => {
        const currentColumns = activeTab === 'jira' ? JiraColumns : GitLabcolumns;
        const { sortingField, isDataSorted } = getSortingValues(currentColumns, column, SortingState);
        const headerSortingState = {
            accessor: sortingField,
            isDataSorted: isDataSorted,
            isSorted: true,
        };
        setState((state) => ({
            ...state,
            sortByColumn: sortingField,
            sortingOrder: isDataSorted,
            headerSortingState: headerSortingState,
        }));
        const payload = getPayload(searchKey, sortingField, isDataSorted);
        fetchData(payload, pageNo, pageLimit);
    };


    const JiraColumns = [
        {
            Header: "Project",
            accessor: "projectName",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ value }) => {
                return <>{value ? value : "-"}</>;
            },
        },
        {
            Header: "Project Key",
            accessor: "projectKey",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ value }) => {
                return <>{value ? value : "-"}</>;
            },
        },
        ...(activeTab === "jira" ? [{
            Header: "Project Lead",
            accessor: "projectLeadFullName",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ value }) => <>{value ? value : "-"}</>,
        }] : []),
        {
            Header: "Application Name",
            accessor: "appNames",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ row, value }) => {
                if (Array.isArray(value)) {
                    return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
                } else {
                    return <>{value ? value : "-"}</>;
                }
            }
        },
        ...(activeTab === "sonarQube" ? [{
            Header: "Last Analysis Date",
            accessor: "lastAnalysisDate",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            tdClassName: "text-center",
            disableSortBy: true,
            Cell: ({ value }) => <>{value ? value : "-"}</>,
        }] : []),
    ];

    const GitLabcolumns = [

        {
            Header: "Sub-Group",
            accessor: "subGroupName",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ value }) => {
                return <>{value ? value : "-"}</>;
            },
        },
        {
            Header: "Project",
            accessor: "projectName",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ value }) => {
                return <>{value ? value : "-"}</>;
            },
        },
        {
            Header: "Application Name",
            accessor: "appNames",
            className: "text-start",
            thClassName: "text-center businesCofgTabAlign",
            disableSortBy: true,
            Cell: ({ row, value }) => {
                if (Array.isArray(value)) {
                    return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
                } else {
                    return <>{value ? value : "-"}</>;
                }
            }
        },
    ];

    const onSearch = (key) => {
        setSearchKey(key);
        setPageNo(0);
        const payload = getPayload(key);
        fetchData(payload, 0, pageLimit);
    };

    const handlePageNoChange = (pageNumber) => {
        setPageNo(pageNumber);
        const payload = getPayload();
        fetchData(payload, pageNumber, pageLimit);
    };

    const handlePageLimitChange = (Limit) => {
        setPageLimit(Limit);
        setPageNo(0);
        const payload = getPayload();
        fetchData(payload, 0, Limit);
    };
    const columns = (activeTab === 'jira' || activeTab === "sonarQube") ? JiraColumns : GitLabcolumns;
    const data = activeTab === 'jira' ? projectJiraListData?.data : activeTab === "sonarQube" ? projectSonarCubeListData?.data || [] : projectGitLabListData?.data || [];
    const isLoading = activeTab === 'jira' ? (projectJiraListLoading) : activeTab === "sonarQube" ? projectSonarCubeListLoading : projectGitLabListLoading;
   console.log(data);
    return (
        <>
            <div className="row">
                <div id="tableCol">
                    <div className="grid-table business-table">
                        <CompleteTableData
                            isLoading={isLoading}
                            data={data || []}
                            tbodyClass={"text-business"}
                            columns={columns}
                            listCount={listCount}
                            pageLimit={pageLimit}
                            onSearch={onSearch}
                            onPageNoChange={handlePageNoChange}
                            onPageLimitChange={handlePageLimitChange}
                            searchKey={searchKey}
                            isTableFilterDisabled={false}
                            totalPageCount={finalPageCount}
                            curentPageNumber={pageNo}
                            headerSortingState={state.headerSortingState}
                            onSorting={handleOnSorting}
                            moveSearchToEnd={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
function areEqual(prevProps, nextProps) {
    if (_.isEqual(prevProps.key, nextProps.key) &&
        _.isEqual(prevProps.activeTab, nextProps.activeTab)) {
        return true;
    } else {
        return false;
    }
}
JiraLanding.prototype = {
    key: PropTypes.string,
    activeTab: PropTypes.string
};
export default React.memo(JiraLanding, areEqual);